import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueSnackbar } from 'notistack'
import { Grid, Paper, Switch, Typography } from '@mui/material'
import { useState } from 'react'
import LgGroupingCofirmModal from './lgGroupingCofirmModal'
import { globalPostService } from '../../../../utils/globalApiServices'
import { checkApiStatus } from '../../../../utils'
import { lgGroupingApi } from '../apiServices'
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators'
import '../styles/headlines.scss'

const LgGrouping = () => {
  const params = useParams();
  const dispatch = useDispatch()
  const { leaseBasicDetails, permission } = useSelector((state) => state.leases);
  const [lgGrouping, setLgGrouping] = useState({ modal: false })
  const [lgGroupingFlag, setLgGroupingFlag] = useState(leaseBasicDetails?.is_grouped || false)
  const [isLoading, setLoading] = useState(false);
  const hasUpdatePermission = Boolean(permission?.permissions?.lease_revamp_application?.lease_revamp?.headlines?.includes('U'))

  const handleLgGroupingFunction = (status) => {
    setLoading(true);
    globalPostService(lgGroupingApi({ lease_slug: params?.leaseSlug }), { is_grouped: status })
      .then((response) => {
        if (checkApiStatus(response)) {
          setLoading(false);
          setLgGroupingFlag(response?.data?.data?.is_grouped)
          dispatch(fetchLeaseBasicDetails({ slug: params?.leaseSlug, setLoading }));
          setLgGrouping({ modal: false, })
          enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
        } else {
          setLoading(false);
          enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
        }
      })
  }
  const handleLGSwitch = () => {
    if (!lgGroupingFlag) { setLgGrouping({ modal: true }) }
    else {
      if (leaseBasicDetails?.is_active_reserve_lg_group) { enqueueSnackbar("Landing Gear grouping cannot be disabled because active reserve rates are associated with it.", { variant: 'error', anchorOrigin: { horizontal: "right", vertical: "top" }, }); }
      else { handleLgGroupingFunction(false) }
    }
  }
  return (
    <>
      <Paper elevation={0} className="lg-grouping-paper">
        <Grid container justifyContent="space-between" alignItems="flex-start" wrap="nowrap">
          <Grid className="lg-grouping-left">
            <Grid display="flex" alignItems="center" gap={1}>
              <Typography className="lg-grouping-title"> Landing Gear (LG) Grouping </Typography>
            </Grid>
            <Typography className="lg-grouping-description"> When enabled, all three on-wing Landing Gears (LG1, LG2, LG3) are managed as a single group across Reserve Rates, Utilization, and Invoicing. Individual utilization records and invoice allocations are created automatically in the background based on defined allocation percentages. </Typography>
          </Grid>
          <Grid className="lg-grouping-right">
            <Switch checked={lgGroupingFlag} onClick={handleLGSwitch} disabled={!hasUpdatePermission} className="lg-grouping-switch" />
          </Grid>
        </Grid>
      </Paper>
      {lgGrouping?.modal ?
        <LgGroupingCofirmModal
          lgGrouping={lgGrouping}
          onToggleModal={() => setLgGrouping({ modal: false, mode: '', data: null })}
          getResponseBack={handleLgGroupingFunction}
          isLoading={isLoading}
        /> : null
      }
    </>

  )
}

export default LgGrouping